export default __webpack_public_path__ + "static/media/elevate-wellness-logo.d5b1eb59.png";